<template>
  <div id="appCapsule">
    <div class="section mt-2">
      <div class="quick-loan-form">
        <form
          method="POST"
          id="quickLoanForm"
          class="dyno-form"
          onsubmit="return quickLoanFunction(event)"
          autocomplete="off"
        >
          <div class="form-group">
            <div class="mt-pop-desc-txt">
              You are eligable to apply for Rockland Vault quick loan, fill the
              form below to get started.
            </div>
          </div>

          <div class="card app-loans-card">
            <div class="card-body">
              <div class="form-group">
                <label class="mt-form-label">Select Account</label><br />

                <select
                  v-model="accountId"
                  class="form-control"
                  style="width: 100%; height: 45px;"
                >
                  <option
                    v-for="account in accounts"
                    :key="account.id"
                    v-if="account.isActive == 1"
                    :value="account.id"
                    :data-account_number="account.number"
                    >{{ account.type }} ****
                    {{ account.number.slice(-4) }}
                    {{ account.currency.symbol }}{{ account.balance }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="mt-form-label">Type of loan</label><br />
                <select
                  v-model="description"
                  class="form-control"
                  style="width: 100%; height: 45px;"
                >
                  <option value="Student Loan">Student Loan</option>
                  <option value="Home Loan">Home Loan</option>
                  <option value="Personal Loan">Personal Loan</option>
                  <option value="Auto Loan">Auto Loan</option>
                  <option value="Agriculture Loan">Agriculture Loan</option>
                </select>
              </div>

              <div class="form-group">
                <label class="mt-form-label">Loan Amount</label><br />
                <input type="text" class="form-control" v-model="amount" />
              </div>

              <div class="form-group">
                <label class="mt-form-label">Duration</label><br />
                <input type="date" class="form-control" v-model="expiry" />
              </div>
            </div>
          </div>

          <div class="form-group submit">
            <button
              @click.prevent="requestLoan"
              :disabled="processing"
              type="submit"
              name="add_account"
              class="btn btn-primary btn-block btn-lg link-loader"
            >
              {{ processing ? "Processing..." : "Get Loan" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
  data() {
    return {
      loans: [],
      amount: 0,
      expiry: "",
      description: "Student Loan",
      processing: false,
      accountId: null,
      accounts: [],
    };
  },
  methods: {
    showModal() {
      $("#modal-invest").modal("show");
    },
    async requestLoan() {
      if (!this.amount || !this.description || !this.to || this.from) {
        toast.fire({
          type: "error",
          title: "Ensure all fields are filled",
        });
      }
      this.processing = true;
      let data = {
        amount: this.amount,
        description: this.description,
        expiry: this.expiry,
        account: this.accountId,
      };
      try {
        await AR.userLoanRequest(data);
        $("#modal-invest").modal("hide");
        this.processing = false;
        this.loadLoans();
        toast.fire({
          type: "success",
          title: "Loan request has been sent successfully",
        });
        this.$router.push({ name: "mobile-transactions" });
      } catch (error) {
        this.processing = false;

        console.log(error);
      }
    },
    async loadLoans() {
      try {
        let res = await AR.userFetchLoans();
        this.loans = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    AR.loggedInUser().then((response) => {
      this.accounts = response.data.accounts;
      this.accountId = this.accounts[0].id;
    });
    this.loadLoans();
  },
};
</script>
